import { defineMessages } from 'react-intl-next';

// We are not really using react-intl in this mini app.
// But here we are still defined them as react-intl format
// So the extraction job can send strings to the vendor to translate.
export const i18n = defineMessages({
	title: {
		id: 'browser-not-supported.title',
		defaultMessage: 'Browser not supported',
		description: 'Head line of a screen shows "browser not supported" message',
	},
	viewSupported: {
		id: 'browser-not-supported.view-supported',
		defaultMessage: 'View supported browsers',
		description: 'Label of a button',
	},
});
